export const model = {
    fields: {
        name: {
            isRequired: true
        },
        shortName: {
            isRequired: true
        },
        size: {
            isRequired: true
        },
        density: {
            isRequired: true
        },
        price: {
            isRequired: true
        },
        margin: {
            isRequired: false
        },
    }
}